
export interface UserInfoModel {
    lineUserId: string
    nationalId: string
    mobile: string
    consent: boolean
    accessToken: string
}

export const initUserInfo = () => {
    const model: UserInfoModel = {lineUserId: "", nationalId: "", mobile: "", consent: false, accessToken: ""}
    return model
}